import { render, staticRenderFns } from "./CustomInformation.vue?vue&type=template&id=76b129fa&scoped=true"
import script from "./CustomInformation.vue?vue&type=script&lang=js"
export * from "./CustomInformation.vue?vue&type=script&lang=js"
import style0 from "./CustomInformation.vue?vue&type=style&index=0&id=76b129fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b129fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b129fa')) {
      api.createRecord('76b129fa', component.options)
    } else {
      api.reload('76b129fa', component.options)
    }
    module.hot.accept("./CustomInformation.vue?vue&type=template&id=76b129fa&scoped=true", function () {
      api.rerender('76b129fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/CustomInformation.vue"
export default component.exports